import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import FunctionTerm from '../components/FunctionTerm';
import PropertyTerm from '../components/PropertyTerm';
import ParamsTable from '../components/ParamsTable';
import ExampleItems from '../components/ExampleItems';
import NormalList from '../components/NormalList';

var Overview =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Overview, _React$Component);

  function Overview() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Overview.prototype;

  _proto.getTitleComponent = function getTitleComponent(isTypedef) {
    var _this$props$data = this.props.data,
        deprecated = _this$props$data.deprecated,
        name = _this$props$data.name,
        types = _this$props$data.types,
        codeInfo = _this$props$data.codeInfo;
    var component = null;

    if (isTypedef) {
      component = React.createElement(PropertyTerm, {
        deprecated: deprecated,
        name: name,
        types: types,
        codeInfo: codeInfo
      });
    } else {
      component = React.createElement(FunctionTerm, {
        deprecated: deprecated,
        name: name,
        codeInfo: codeInfo
      });
    }

    return component;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        parentPid = _this$props.parentPid,
        data = _this$props.data,
        hasProperties = _this$props.hasProperties;
    var deprecated = data.deprecated,
        name = data.name,
        description = data.description,
        codeInfo = data.codeInfo,
        examples = data.examples,
        sees = data.sees,
        todos = data.todos,
        augments = data.augments,
        params = data.params;
    var popItems = [sees.slice(), todos.slice(), augments.slice(), params.slice()];
    popItems.forEach(function (items) {
      if (items.length) {
        items.pop(); // remove default item
      }
    });
    return React.createElement("div", {
      className: "overview"
    }, React.createElement("div", {
      className: "subsection"
    }, React.createElement("dl", null, React.createElement("dt", {
      className: "subsection-term"
    }, this.getTitleComponent(parentPid === 'typedef')), React.createElement("dd", {
      className: "subsection-description"
    }, React.createElement("p", {
      className: "description",
      dangerouslySetInnerHTML: {
        __html: description
      }
    }), popItems[0].length ? React.createElement(NormalList, {
      title: 'SEES',
      items: popItems[0]
    }) : null, popItems[1].length ? React.createElement(NormalList, {
      title: 'TODOS',
      items: popItems[1]
    }) : null, popItems[2].length ? React.createElement(NormalList, {
      title: 'EXTENDS',
      items: popItems[2]
    }) : null, React.createElement(ParamsTable, {
      properties: popItems[3],
      isPropertyTitle: hasProperties
    }), examples.length ? React.createElement(ExampleItems, {
      items: examples
    }) : null))));
  };

  return Overview;
}(React.Component);

export default Overview;